import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';
import type { Props } from '../types';
import { useCallback } from 'react';

export const MobileLayout = ({
  errors,
  values,
  onChange,
  onSetFairValue,
  isLoading,
  onSubmit,
  submitLabel,
  owner,
  initialContentHtml,
  initialFairValue,
  company,
  onReset,
  pastAnnualRevenueEarnings,
  calculationBreakDownOutput,
  narrativeId,
  onContentChange,
  onHeaderChange,
  hasSavedContent,
  setSuccessSnackbar,
  isPublishedLocked,
  cancelLabel,
}: Props) => {
  const handleSubmit = useCallback(() => {
    setSuccessSnackbar?.(true);
    onSubmit();
  }, [onSubmit, setSuccessSnackbar]);

  const handleContentChange = useCallback(
    ({ text, html }: { text: string; html: string }) => {
      onContentChange({ text, html });
      setSuccessSnackbar?.(true);
    },
    [onContentChange, setSuccessSnackbar]
  );

  const handleHeaderChange = useCallback(
    (title: string) => {
      onHeaderChange(title);
      setSuccessSnackbar?.(true);
    },
    [onHeaderChange, setSuccessSnackbar]
  );

  return (
    <>
      <div className="grid grid-rows-[min-content_auto] content-start gap-x2">
        <NarrativeHeader
          errors={errors}
          values={values}
          onChange={handleHeaderChange}
          isLoading={isLoading}
          onSubmit={handleSubmit}
          submitLabel={submitLabel}
          owner={owner}
          company={company}
          hasSavedContent={hasSavedContent}
          isPublishedLocked={isPublishedLocked}
          cancelLabel={cancelLabel}
        />

        <NarrativeSidebar
          company={company}
          onChange={onChange}
          onSetFairValue={onSetFairValue}
          values={values}
          onReset={onReset}
          readOnly={false}
          owner={{
            displayName: owner?.displayName || '',
            publicId: owner?.publicId || '',
          }}
          narrativeType={'USER'}
          pastAnnualRevenueEarnings={pastAnnualRevenueEarnings}
          narrativeId={narrativeId}
          calculationBreakDownOutput={calculationBreakDownOutput}
          initialFairValue={initialFairValue}
        />
      </div>
      <PublicNarrativeRichTextEditor
        onUpdate={handleContentChange}
        defaultContent={initialContentHtml}
      />
    </>
  );
};
